import React, {PureComponent} from 'react';
import edapWrapper from '@homeaway/edap-wrapper';
import './LinkpileItem.less';
import {
    EDAP_GENERIC_EVENT,
    EDAP_INTERACTION_CLICK,
    EDAP_LINK_CLICK,
    EDAP_TABBED_LINKPILE_ACTION_LOCATION
} from '../../constants';

class LinkpileItem extends PureComponent {
    static defaultProps = {
        actionlocation: EDAP_TABBED_LINKPILE_ACTION_LOCATION,
        style: {}
    };

    handleClick() {
        const {href, actionlocation} = this.props;
        edapWrapper().push({
            name: EDAP_GENERIC_EVENT,
            data: {
                actionlocation,
                eventcategory: EDAP_INTERACTION_CLICK,
                eventaction: EDAP_LINK_CLICK,
                eventrefinements: `url=${href}`
            }
        });
    }

    render() {
        const props = this.props;
        let linkData = {
            href: props.href,
            title: props.title,
            style: props.style,
            onClick: this.handleClick.bind(this)
        };
        return (
            <a
                className="linkpile__linkpile-item"
                {...linkData}
            >
                <div className="linkpile__linkpile-item-title">
                    {props.title}
                </div>
                <div className="linkpile__linkpile-item-subtitle">
                    {props.subtitle}
                </div>
            </a>
        );
    }
}

export default LinkpileItem;
